// NEOGRIPX — Shopify Theme JS

// ── Blindaje de enlaces de contacto frente a apps de tracking ──
// Algunas apps de píxeles (ej. Meta/Facebook) interceptan el clic en
// enlaces salientes como WhatsApp para medir campañas, y a veces esa
// redirección propia viene rota y da un error 404 en vez de abrir el
// enlace real. Se corta el evento en fase de captura (antes que
// cualquier otro script de la página pueda reaccionar a él) para que
// estos enlaces naveguen siempre con normalidad.
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="wa.me"], a[href^="tel:"], a[href^="mailto:"]');
  if (link) e.stopImmediatePropagation();
}, true);

// ── Chispas al añadir al carrito ──
// Líneas finas en los colores de la marca que salen desde detrás del botón
// hacia fuera. Se pintan en una capa fija para que ningún contenedor las recorte.
const nxCelebrate = (btn) => {
  if (!btn || !btn.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Si se pulsó desde la barra fija del móvil, el botón de la ficha no se ve: salen de la barra
  const bar = document.querySelector('[data-nx-sticky].is-visible .nx-sticky-btn');
  const b0 = btn.getBoundingClientRect();
  const target = bar && (b0.bottom < 0 || b0.top > window.innerHeight) ? bar : btn;
  const r = target.getBoundingClientRect();
  const layer = document.createElement('div');
  layer.className = 'nx-sparks';
  layer.style.left = (r.left + r.width / 2) + 'px';
  layer.style.top = (r.top + r.height / 2) + 'px';
  document.body.appendChild(layer);
  const colors = ['#7B2FFF', '#FF00FF', '#A43BFF'];
  // En el botón ancho de la ficha, más chispas y más largas para que se vean
  const wide = r.width > 150;
  const n = wide ? 22 : 14;
  const rand = (a, b) => a + Math.random() * (b - a);
  for (let i = 0; i < n; i++) {
    const a = (i / n) * Math.PI * 2 + rand(-0.15, 0.15);
    const cx = Math.cos(a);
    const cy = Math.sin(a);
    // Nace en el borde del botón y se aleja hacia fuera
    const x0 = cx * (r.width / 2 - 6);
    const y0 = cy * (r.height / 2 - 4);
    const d = wide ? rand(26, 46) : rand(16, 30);
    const x1 = x0 + cx * d * (wide ? 1.5 : 1);
    const y1 = y0 + cy * d;
    const len = wide ? rand(12, 20) : rand(8, 13);
    const deg = (a * 180) / Math.PI + 90;
    const el = document.createElement('span');
    el.className = 'nx-spark';
    el.style.height = len + 'px';
    if (wide) el.style.width = '3px';
    el.style.margin = (-len / 2) + 'px 0 0 -1px';
    el.style.background = colors[i % 3];
    el.animate([
      { transform: `translate(${x0}px, ${y0}px) rotate(${deg}deg) scaleY(0.2)`, opacity: 0, easing: 'cubic-bezier(.2,.8,.4,1)' },
      { transform: `translate(${x0 + (x1 - x0) * 0.4}px, ${y0 + (y1 - y0) * 0.4}px) rotate(${deg}deg) scaleY(1)`, opacity: 1, offset: 0.3 },
      { transform: `translate(${x0 + (x1 - x0) * 0.75}px, ${y0 + (y1 - y0) * 0.75}px) rotate(${deg}deg) scaleY(0.8)`, opacity: 1, offset: 0.65 },
      { transform: `translate(${x1}px, ${y1}px) rotate(${deg}deg) scaleY(0.3)`, opacity: 0 }
    ], { duration: rand(520, 680), fill: 'forwards' });
    layer.appendChild(el);
  }
  target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 260 });
  setTimeout(() => layer.remove(), 800);
};

// Aviso abajo tras añadir desde una tarjeta: el cliente sigue en la página
const nxCartToast = (name) => {
  let toast = document.querySelector('.nx-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'nx-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = '<span class="nx-toast-ok" aria-hidden="true"><svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5l3.2 3L13 4.5"/></svg></span>'
      + '<span class="nx-toast-txt"><b>Añadido al carrito</b><small></small></span>'
      + '<a class="nx-toast-go" href="/cart">Ver carrito y pagar →</a>';
    document.body.appendChild(toast);
  }
  toast.querySelector('small').textContent = name || '';
  toast.classList.add('is-on');
  clearTimeout(toast.nxTimer);
  toast.nxTimer = setTimeout(() => toast.classList.remove('is-on'), 5000);
};

// ── Añadir rápido desde las tarjetas de producto ──
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn-quick-add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.action === 'goto') {
    window.location.href = btn.dataset.url;
    return;
  }

  if (btn.disabled) return;
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(btn.dataset.variant, 10), quantity: 1 })
  })
    .then((r) => { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
    .then((r) => r.json())
    .then((cart) => {
      btn.classList.add('added');
      btn.textContent = '✓ Añadido';
      nxCelebrate(btn);
      nxCartToast(btn.closest('.product-card')?.querySelector('.product-name')?.textContent.trim());

      let badge = document.querySelector('.nav-cart-count');
      if (!badge) {
        const cartIcon = document.querySelector('.nav-cart');
        if (cartIcon) {
          badge = document.createElement('span');
          badge.className = 'nav-cart-count';
          cartIcon.appendChild(badge);
        }
      }
      // Las unidades de «Personalización del kit» son zonas, no productos
      if (badge) badge.textContent = cart.items.reduce((n, i) => n + (i.handle === 'personalizacion-del-kit' ? 0 : i.quantity), 0);

      setTimeout(() => {
        btn.classList.remove('added');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1600);
    })
    .catch(() => {
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1600);
    });
});

document.addEventListener('DOMContentLoaded', () => {

  // ── Navbar scroll ──
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // ── Mobile nav toggle ──
  const hamburger = document.getElementById('hamburger');
  const navLinks = document.getElementById('navLinks');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('open');
      hamburger.classList.toggle('open');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    navLinks.querySelectorAll('a:not(.nav-dropdown-trigger)').forEach(a => {
      a.addEventListener('click', () => {
        navLinks.classList.remove('open');
        hamburger.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Hero bg parallax (desktop only) ──
  const heroBg = document.getElementById('heroBg');
  if (heroBg) {
    setTimeout(() => heroBg.classList.add('loaded'), 100);
    if (window.innerWidth > 768) {
      window.addEventListener('scroll', () => {
        heroBg.style.transform = `scale(1.05) translateY(${window.scrollY * 0.15}px)`;
      }, { passive: true });
    }
  }

  // ── Marquesina de fotos (auto-scroll + arrastre + clic) ──
  document.querySelectorAll('[data-marquee]').forEach(wrap => {
    const track = wrap.querySelector('[data-marquee-track]');
    if (!track) return;
    const originalItems = Array.from(track.children);
    if (!originalItems.length) return;

    const speed = parseFloat(wrap.dataset.speed) || 45; // px/segundo
    const pauseOnHover = wrap.dataset.pauseHover === 'true';

    let unit = 0;
    function measureUnit() {
      const first = originalItems[0];
      const last = originalItems[originalItems.length - 1];
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      unit = (last.offsetLeft + last.offsetWidth) - first.offsetLeft + gap;
    }
    function ensureFilled() {
      measureUnit();
      if (unit <= 0) return;
      let guard = 0;
      while (track.scrollWidth < wrap.clientWidth * 2 + unit && guard < 25) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach(a => a.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        });
        guard++;
      }
    }
    ensureFilled();
    window.addEventListener('resize', ensureFilled);

    function wrapPos(v) {
      if (unit <= 0) return v;
      v = v % unit;
      if (v > 0) v -= unit;
      return v;
    }

    let posX = 0;
    let dragging = false;
    let hovering = false;
    let moved = 0;
    let startX = 0;
    let startPos = 0;
    let lastTime = null;

    function tick(time) {
      if (lastTime === null) lastTime = time;
      const dt = (time - lastTime) / 1000;
      lastTime = time;
      if (!dragging && !(pauseOnHover && hovering)) {
        posX = wrapPos(posX - speed * dt);
      }
      track.style.transform = `translateX(${posX}px)`;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    wrap.addEventListener('mouseenter', () => hovering = true);
    wrap.addEventListener('mouseleave', () => hovering = false);

    // Nota: NO se usa setPointerCapture — retargeta el evento "click" al
    // contenedor y rompe la navegación de los enlaces con el botón
    // izquierdo (el clic derecho seguía funcionando porque no depende de
    // eventos de puntero). En su lugar, se escucha en window mientras dura
    // el arrastre para no perder el movimiento si el cursor sale del track.
    function onPointerMove(e) {
      if (!dragging) return;
      const delta = e.clientX - startX;
      moved = Math.max(moved, Math.abs(delta));
      posX = wrapPos(startPos + delta);
    }
    function onPointerUp() {
      dragging = false;
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerUp);
    }
    wrap.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = 0;
      startX = e.clientX;
      startPos = posX;
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);
    });

    // Evita que un arrastre dispare el enlace de la foto (un clic normal,
    // sin apenas movimiento, navega con normalidad)
    track.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', (e) => {
        if (moved > 6) e.preventDefault();
      });
    });
  });

  // ── Scroll reveal ──
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => entry.target.classList.add('visible'), delay);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px 200px 0px' });

  document.querySelectorAll('.product-card').forEach((el, i) => {
    el.dataset.delay = i * 30;
  });

  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
    revealObserver.observe(el);
  });

  // ── Cursor glow ──
  const cursorGlow = document.getElementById('cursorGlow');
  if (cursorGlow) {
    if (window.innerWidth > 768) {
      document.addEventListener('mousemove', (e) => {
        cursorGlow.style.left = e.clientX + 'px';
        cursorGlow.style.top = e.clientY + 'px';
      });
    } else {
      cursorGlow.style.display = 'none';
    }
  }

  // ── Category tab filtering (homepage only — link tabs navigate without JS) ──
  const catTabs = document.querySelectorAll('.cat-tab');
  if (catTabs.length) {
    catTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (!tab.dataset.cat) return; // <a> navigation tab — let browser handle
        catTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const cat = tab.dataset.cat;
        document.querySelectorAll('#productsGrid .product-card').forEach(card => {
          const match = cat === 'all' || card.dataset.cat === cat;
          card.classList.toggle('hidden', !match);
        });
      });
    });
  }

  // ── Navbar dropdown (mobile toggle) ──
  document.querySelectorAll('.nav-dropdown-trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      if (window.innerWidth <= 768) {
        e.preventDefault();
        e.stopPropagation();
        trigger.closest('.nav-dropdown').classList.toggle('open');
      }
    });
  });

  // ── Product gallery thumbnails ──
  const mainImg = document.getElementById('mainProductImg');
  if (mainImg) {
    document.querySelectorAll('.product-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.src = thumb.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Variant selection (radio pills → hidden select) ──
  const variantSelect = document.querySelector('.variant-id-select');
  if (variantSelect) {
    const productId = document.querySelector('[data-product-id]')?.dataset.productId
      || Object.keys(window.NXVariantData || {})[0];
    const priceEl = document.querySelector('.price-value');
    const compareEl = document.querySelector('.price-compare');
    const addBtn = document.querySelector('.add-to-cart-btn');
    const productThumbs = document.querySelectorAll('.product-thumb');

    // Map: image URL → variant id it belongs to (images not listed here are "shared/extra" and always show)
    const imageOwner = {};
    const variantsForProduct = (window.NXVariantData || {})[productId] || {};
    Object.keys(variantsForProduct).forEach(vId => {
      const img = variantsForProduct[vId].image;
      if (img) imageOwner[img] = vId;
    });

    function filterThumbs(currentVariantId) {
      const currentImg = (variantsForProduct[currentVariantId] || {}).image;
      const items = Array.from(productThumbs);

      items.forEach(thumb => {
        const owner = imageOwner[thumb.dataset.src];
        const belongsToOther = owner && owner !== currentVariantId;
        thumb.classList.toggle('thumb-hidden', !!belongsToOther);
      });

      // Reorder visible thumbs: 1) foto del tipo elegido, 2) diagrama de piezas, 3) resto de extras
      const visible = items.filter(t => !t.classList.contains('thumb-hidden'));
      const cover = visible.find(t => t.dataset.src === currentImg);
      const diagram = visible.find(t => t !== cover && /mesa_de_trabajo/i.test(t.dataset.src));
      const rest = visible.filter(t => t !== cover && t !== diagram);
      const ordered = [cover, diagram, ...rest].filter(Boolean);
      const container = items[0] && items[0].parentElement;
      if (container) ordered.forEach(t => container.appendChild(t));

      items.forEach(t => t.classList.remove('active'));
      if (ordered[0]) ordered[0].classList.add('active');
    }

    function syncVariant() {
      const groups = document.querySelectorAll('.variant-group');
      const selected = Array.from(groups).map(g => {
        const checked = g.querySelector('.variant-radio:checked');
        return checked ? checked.value : '';
      });
      const opts = Array.from(variantSelect.options);
      for (const opt of opts) {
        const vals = [opt.dataset.opt1 || '', opt.dataset.opt2 || '', opt.dataset.opt3 || ''];
        if (selected.every((v, i) => !v || v === vals[i])) {
          variantSelect.value = opt.value;
          break;
        }
      }

      const allData = window.NXVariantData || {};
      const data = (allData[productId] || {})[variantSelect.value];
      if (!data) return;

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantSelect.value);
        window.history.replaceState({}, '', url);
      }

      if (mainImg && data.image && mainImg.src !== data.image) {
        mainImg.classList.add('img-swapping');
        setTimeout(() => {
          mainImg.src = data.image;
          mainImg.classList.remove('img-swapping');
        }, 180);
      }
      if (priceEl && data.price) priceEl.textContent = data.price;
      if (compareEl) {
        if (data.compareAtPrice) {
          compareEl.textContent = data.compareAtPrice;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !data.available;
        addBtn.textContent = data.available ? 'Añadir al carrito' : 'Sin stock';
      }
      filterThumbs(variantSelect.value);
    }
    document.querySelectorAll('.variant-radio').forEach(r => r.addEventListener('change', syncVariant));
    if (Object.keys(imageOwner).length) filterThumbs(variantSelect.value);
  }

  // ── PDP: carrusel automático de reseñas ──
  document.querySelectorAll('[data-pdp-carousel]').forEach(carousel => {
    const slides = Array.from(carousel.querySelectorAll('.pdp-review-slide'));
    const dotsWrap = carousel.parentElement.querySelector('[data-pdp-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.pdp-review-dot')) : [];
    if (slides.length < 2) return;
    let current = 0;
    let timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function next() { show((current + 1) % slides.length); }
    function start() { timer = setInterval(next, 4500); }
    function stop() { clearInterval(timer); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); stop(); start(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    start();
  });

  // ── PDP: cierra el hueco entre la ficha de compra y la descripción a ancho completo ──
  function adjustDescGap() {
    const desc = document.querySelector('.product-page-desc-full');
    const layout = document.querySelector('.product-layout');
    const infoPanel = document.querySelector('.product-info-panel');
    if (!desc || !layout || !infoPanel) return;
    if (window.innerWidth < 901) { desc.style.marginTop = ''; return; }
    const layoutBottom = layout.getBoundingClientRect().bottom;
    const infoBottom = infoPanel.getBoundingClientRect().bottom;
    const gap = infoBottom - layoutBottom; // 0 or negative: how much shorter the buy-box column is
    desc.style.marginTop = Math.min(0, gap - 12) + 'px';
  }
  if (document.querySelector('.product-page-desc-full')) {
    window.addEventListener('load', adjustDescGap);
    window.addEventListener('resize', adjustDescGap);
  }

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── Section background parallax ──
  const parallaxBgs = document.querySelectorAll('.anim-parallax');
  if (parallaxBgs.length && window.innerWidth > 768) {
    const onScroll = () => {
      parallaxBgs.forEach(bg => {
        const wrap = bg.closest('.section-bg-wrap');
        if (!wrap) return;
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const offset = (progress - 0.5) * 80;
        bg.style.transform = `translateY(${offset}px) scale(1.12)`;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Shopify editor: re-reveal content after section updates ──
  if (window.Shopify && window.Shopify.designMode) {
    const makeVisible = (root) => {
      root.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
        el.classList.add('visible');
      });
    };
    makeVisible(document);
    document.addEventListener('shopify:section:load', (e) => makeVisible(e.target));
    document.addEventListener('shopify:section:reorder', () => makeVisible(document));
  }

  // ── Smooth anchor scroll with navbar offset ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const barH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announce-h') || '0', 10);
      const top = target.getBoundingClientRect().top + window.scrollY - 80 - barH;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

});

// ── Venta cruzada en la ficha (snippet nx-addon) ──
// Casilla "Añade el protector de horquilla": si está marcada, el formulario
// añade el kit y la horquilla en una sola petición y lleva al carrito.
// Botón de pack: añade el pack con la misma modalidad elegida en el kit.
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('AddToCartForm');
  if (!form) return;
  const variantSelect = form.querySelector('.variant-id-select');
  const addonCheck = form.querySelector('.nx-addon-check'); const bikeOption = form.querySelector('[data-nx-bike-option]'); if (bikeOption) { const bikeError = bikeOption.querySelector('[data-nx-bike-error]'); const stopIfNoBike = (e) => { if (bikeOption.querySelector('.variant-radio:checked')) return; e.preventDefault(); e.stopImmediatePropagation(); if (bikeError) bikeError.hidden = false; bikeOption.scrollIntoView({ behavior: 'smooth', block: 'center' }); }; form.addEventListener('submit', stopIfNoBike, true); form.querySelector('[data-nx-pack-add]')?.addEventListener('click', stopIfNoBike, true); bikeOption.addEventListener('change', () => { if (bikeError) bikeError.hidden = true; }); }

  const goToCart = (items, btn) => {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Añadiendo...'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    }).then((r) => {
      if (!r.ok) throw new Error('add failed');
      celebrateAndGo(btn);
    });
  };
  // Confirma con las chispas y, en cuanto se han visto, lleva al carrito
  const celebrateAndGo = (btn) => {
    if (btn) btn.textContent = '✓ Añadido';
    nxCelebrate(btn);
    setTimeout(() => { window.location.href = '/cart'; }, 650);
  };

  // Personalización (snippet nx-personaliza): una unidad del producto oculto por zona
  const nxp = form.querySelector('[data-nxp]');
  const nxpZones = () => (nxp && nxp.dataset.nxpVariant ? parseInt(nxp.dataset.nxpCount, 10) || 0 : 0);
  const nxpCents = () => nxpZones() * (parseInt(nxp?.dataset.nxpZoneCents, 10) || 0);
  const kitProperties = () => {
    const properties = {};
    form.querySelectorAll('input[name^="properties["]:not(:disabled)').forEach((input) => {
      properties[input.name.slice(11, -1)] = input.value;
    });
    return properties;
  };
  const nxpItems = (kitItem) => {
    const properties = kitProperties();
    if (Object.keys(properties).length) kitItem.properties = properties;
    const items = [kitItem];
    const n = nxpZones();
    if (n) {
      // Sin propiedades: todas las zonas del carrito van en una sola línea
      items.push({ id: parseInt(nxp.dataset.nxpVariant, 10), quantity: n });
    }
    return items;
  };

  if (addonCheck) {
    form.addEventListener('submit', (e) => {
      if (!addonCheck.checked) return;
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      goToCart([
        { id: parseInt(variantSelect.value, 10), quantity: 1 },
        { id: parseInt(addonCheck.dataset.nxAddon, 10), quantity: 1 }
      ], btn).catch(() => form.submit());
    });
  }

  // Selector de packs del kit (snippet nx-pack-builder): Solo / Pack Pro / Pack Total
  const builder = document.querySelector('[data-nx-pack-builder]');
  if (builder) {
    const addBtn = form.querySelector('.add-to-cart-btn');
    const extras = builder.querySelector('[data-nx-pack-extras]');
    const hbPick = builder.querySelector('[data-nx-pick="handlebar"]');
    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
    const picked = (group) => builder.querySelector(`input[name="nx_pack_${group}"]:checked`);
    const level = () => (builder.querySelector('.nx-pack-radio:checked') || {}).value || 'solo';
    const labels = { solo: 'Añadir al carrito', pro: 'Añadir Pack Pro', total: 'Añadir Pack Total' };
    const mainPrice = document.querySelector('.product-page-price .price-value');
    // Junto al precio grande, qué incluye la opción elegida
    const priceLabels = { solo: 'Kit Protector de Cuadro', pro: 'Pack Pro · Cuadro + Horquilla', total: 'Pack Total · Cuadro + Horquilla + Manillar' };
    let priceLabel = null;
    if (mainPrice) {
      priceLabel = document.createElement('span');
      priceLabel.className = 'nx-price-label';
      mainPrice.parentNode.appendChild(priceLabel);
    }
    let prices = {};

    const update = () => {
      const kit = parseInt(builder.dataset.kitPrice, 10) || 0;
      const fork = parseInt((picked('fork') || {}).dataset?.price, 10) || 0;
      const hb = parseInt((picked('handlebar') || {}).dataset?.price, 10) || 0;
      prices = {
        solo: kit,
        pro: kit + fork - (parseInt(builder.dataset.proSaving, 10) || 0),
        total: kit + fork + hb - (parseInt(builder.dataset.totalSaving, 10) || 0)
      };
      Object.keys(prices).forEach((k) => {
        const el = builder.querySelector(`[data-nx-level-price="${k}"]`);
        if (el) el.textContent = fmt(prices[k]);
      });
      const lv = level();
      builder.querySelectorAll('.nx-pack-radio').forEach((r) => {
        r.closest('.pack-option').classList.toggle('pack-option-active', r.checked);
      });
      builder.querySelectorAll('.nx-pack-item-radio').forEach((r) => {
        r.closest('.nx-pack-item').classList.toggle('is-active', r.checked);
      });
      extras.hidden = lv === 'solo';
      hbPick.hidden = lv !== 'total';
      // El precio grande de la ficha y el botón muestran siempre lo que se va a pagar
      const pay = prices[lv] + nxpCents();
      if (mainPrice) mainPrice.textContent = fmt(pay);
      if (priceLabel) priceLabel.textContent = priceLabels[lv] + (nxpZones() ? ' + Personalización' : '');
      if (addBtn && !addBtn.disabled) addBtn.textContent = labels[lv] + ' · ' + fmt(pay);
    };
    builder.addEventListener('change', update);
    form.addEventListener('nxp:change', update);

    // ?pack=solo|pro|total en la URL (p. ej. desde el menú) marca ese nivel al entrar
    const packParam = new URLSearchParams(window.location.search).get('pack');
    const packRadio = packParam && builder.querySelector(`.nx-pack-radio[value="${['solo', 'pro', 'total'].includes(packParam) ? packParam : ''}"]`);
    if (packRadio) packRadio.checked = true;

    // El cambio de modalidad reescribe el botón: se vuelve a poner el texto del pack
    if (variantSelect) {
      form.querySelectorAll('.variant-radio').forEach((r) => r.addEventListener('change', () => setTimeout(update, 0)));
    }

    form.addEventListener('submit', (e) => {
      const lv = level();
      if (lv === 'solo' && !nxpZones()) return;
      e.preventDefault();
      // La personalización va como propiedades del kit, más su cargo por zona
      const items = nxpItems({ id: parseInt(variantSelect.value, 10), quantity: 1 });
      const fork = picked('fork');
      if (lv !== 'solo' && fork) items.push({ id: parseInt(fork.value, 10), quantity: 1 });
      const hb = picked('handlebar');
      if (lv === 'total' && hb) items.push({ id: parseInt(hb.value, 10), quantity: 1 });
      goToCart(items, addBtn).catch(() => {
        addBtn.disabled = false;
        update();
      });
    });
    update();
  } else if (nxp) {
    // Kit sin packs: si hay personalización, se añade el kit con su cargo por zona
    form.addEventListener('submit', (e) => {
      if (!nxpZones()) return;
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      goToCart(nxpItems({ id: parseInt(variantSelect.value, 10), quantity: 1 }), btn).catch(() => form.submit());
    });
  }

  const packBtn = form.querySelector('[data-nx-pack-add]');
  if (packBtn) {
    packBtn.addEventListener('click', () => {
      let map = {};
      try { map = JSON.parse(packBtn.dataset.variants); } catch (err) { map = {}; }
      const kitTitle = variantSelect.options[variantSelect.selectedIndex]?.textContent.split(' — ')[0].trim();
      const packVariant = map[kitTitle] || Object.values(map)[0];
      if (!packVariant) return;
      goToCart([{ id: packVariant, quantity: 1 }], packBtn).catch(() => {
        packBtn.disabled = false;
        packBtn.textContent = packBtn.dataset.label || 'Añadir al carrito';
      });
    });
  }

  // Resto de casos (kit solo, productos sin packs): la misma animación antes del carrito.
  // Va la última, así solo actúa si ningún caso anterior se ha encargado del envío.
  form.addEventListener('submit', (e) => {
    if (e.defaultPrevented) return;
    e.preventDefault();
    const btn = form.querySelector('.add-to-cart-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then((r) => { if (!r.ok) throw new Error('add failed'); celebrateAndGo(btn); })
      .catch(() => form.submit());
  });
});

// ── Barra de compra fija en móvil (ficha de producto) ──
// Se muestra mientras el botón "Añadir al carrito" no está en pantalla y
// pulsa ese mismo botón, para respetar modalidad y venta cruzada.
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-nx-sticky]');
  const mainBtn = document.querySelector('#AddToCartForm .add-to-cart-btn');
  if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
  const barBtn = bar.querySelector('.nx-sticky-btn');
  const barPrice = bar.querySelector('[data-nx-sticky-price]');
  const mainPrice = document.querySelector('.product-page-price .price-value');

  const setVisible = (on) => {
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    barBtn.tabIndex = on ? 0 : -1;
    document.body.classList.toggle('nx-sticky-on', on);
  };
  new IntersectionObserver((entries) => {
    entries.forEach((entry) => setVisible(!entry.isIntersecting));
  }, { threshold: 0 }).observe(mainBtn);

  // Mantiene precio y estado sincronizados con la modalidad elegida
  const sync = () => {
    if (mainPrice) barPrice.textContent = mainPrice.textContent;
    barBtn.disabled = mainBtn.disabled;
    barBtn.textContent = mainBtn.textContent.trim();
  };
  new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, characterData: true, subtree: true });
  if (mainPrice) new MutationObserver(sync).observe(mainPrice, { childList: true, characterData: true, subtree: true });
  sync();

  barBtn.addEventListener('click', () => {
    if (mainBtn.disabled) return;
    barBtn.textContent = 'Añadiendo...';
    mainBtn.click();
  });
});

// ── Colección: accesos rápidos Transparentes / Con diseño ──
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('[data-nx-grid]');
  const buttons = document.querySelectorAll('.nx-kind-btn');
  if (!grid || !buttons.length) return;
  buttons.forEach((btn) => btn.addEventListener('click', () => {
    const kind = btn.dataset.nxKind;
    grid.dataset.filter = kind;
    buttons.forEach((b) => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    grid.querySelectorAll('.reveal').forEach((el) => el.classList.add('visible'));
  }));
  // Enlaces del menú (?tipo=transparente | diseno) abren la colección ya filtrada
  const tipo = new URLSearchParams(window.location.search).get('tipo');
  const preset = ['transparente', 'diseno'].includes(tipo) && document.querySelector(`.nx-kind-btn[data-nx-kind="${tipo}"]`);
  if (preset) preset.click();
});

// ── Ficha: fecha de entrega estimada bajo el botón ──
// 2–4 días laborables; los pedidos hechos después de las 14:00 cuentan desde mañana.
document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('[data-nx-delivery]');
  if (!el) return;
  const addWorkdays = (date, n) => {
    const d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  };
  const now = new Date();
  const start = now.getHours() >= 14 ? addWorkdays(now, 1) : now;
  const from = addWorkdays(start, 3), to = addWorkdays(start, 4);
  const day = (d) => d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric' });
  const month = (d) => d.toLocaleDateString('es-ES', { month: 'long' });
  const fromText = from.getMonth() === to.getMonth() ? day(from) : `${day(from)} de ${month(from)}`;
  el.innerHTML = `Pídelo hoy y recíbelo entre el <b>${fromText}</b> y el <b>${day(to)} de ${month(to)}</b>`;
  el.hidden = false;
});

// ── Ficha: descripción en desplegables, sin emojis ──
// Cada título (h2) y lo que va debajo pasa a ser un desplegable; se añaden
// "Instalación" y "Envío y devoluciones". La parte de "Selecciona tu tipo de
// bicicleta" se quita porque ya la resuelve el selector de modalidad.
document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('.product-page-desc-full');
  if (!box || box.dataset.nxAcc) return;
  box.dataset.nxAcc = '1';
  const clean = (node) => {
    node.querySelectorAll('p, li, h2, h3').forEach((el) => {
      const before = el.innerHTML;
      const after = before.replace(/^\s*(✔️?|✅|✓)\s*/u, '').replace(/\s*\p{Extended_Pictographic}️?/gu, '');
      if (after !== before) { el.innerHTML = after; if (/^\s*(✔|✅|✓)/u.test(before)) el.classList.add('nx-check'); }
    });
  };
  const kids = Array.from(box.children);
  const intro = document.createElement('div'); intro.className = 'nx-desc-intro';
  const groups = [];
  let current = null;
  kids.forEach((el) => {
    if (el.tagName === 'HR') return;
    if (el.tagName === 'H2') { current = { title: el.textContent.trim(), nodes: [] }; groups.push(current); return; }
    if (current) current.nodes.push(el); else intro.appendChild(el);
  });
  const acc = document.createElement('div'); acc.className = 'nx-acc';
  const addPanel = (title, nodes, html) => {
    const d = document.createElement('details'); d.className = 'nx-acc-item';
    const s = document.createElement('summary'); s.textContent = title; d.appendChild(s);
    const body = document.createElement('div'); body.className = 'nx-acc-body';
    if (html) body.innerHTML = html; else nodes.forEach((n) => body.appendChild(n));
    d.appendChild(body); acc.appendChild(d);
  };
  groups.forEach((g) => {
    if (/^selecciona tu tipo/i.test(g.title)) return;
    // El lema suelto del final (h3 tras la última sección) no aporta en un desplegable
    const nodes = g.nodes.filter((n) => !(n.tagName === 'H3' && g === groups[groups.length - 1]));
    addPanel(g.title, nodes);
  });
  addPanel('Instalación', null, '<p>Se instala en seco y sin herramientas: limpia y seca bien el cuadro, coloca cada pieza en su sitio y presiónala bien. En unos 30 minutos lo tienes instalado. El secador no es necesario, pero sí recomendado en las curvas.</p><p>Con tu pedido te enviamos las instrucciones paso a paso, y si tienes dudas te ayudamos por WhatsApp.</p>');
  addPanel('Envío y devoluciones', null, '<p>En stock, envío en 3–4 días laborables a España peninsular; Baleares y Canarias, algunos días más. Kits personalizados, 7 días. Envío gratis en pedidos desde 70 €.</p><p>30 días de devolución en kits estándar sin abrir y en buen estado; revisamos su estado antes de aceptarla. Los kits personalizados no admiten devolución salvo defecto de fabricación; si algo llega mal, lo solucionamos sin coste.</p>');
  box.innerHTML = '';
  if (intro.children.length) box.appendChild(intro);
  box.appendChild(acc);
  clean(box);
});

// ── Ficha: reseñas de Judge.me sin la pestaña de reseñas de producto vacía ──
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('judgeme_product_reviews');
  if (!root) return;
  const tidy = () => {
    root.querySelectorAll('button.jdgm-tab').forEach((b) => { if (/\(0\)/.test(b.textContent)) b.style.display = 'none'; });
    root.querySelectorAll('.jdgm-tab-dropdown__select option').forEach((o) => { if (/\(0\)/.test(o.textContent)) o.hidden = true; });
  };
  tidy();
  new MutationObserver(tidy).observe(root, { childList: true, subtree: true });
});

// ── Colección de kits: filtrar por estilo (grietas, mármol, leopardo…) ──
// El estilo sale del nombre del producto, así que un kit nuevo entra solo en su grupo.
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('[data-nx-grid]');
  const kinds = document.querySelector('.nx-kind-filter');
  if (!grid || !kinds) return;
  const STYLES = [
    { key: 'rayos', label: 'Grietas y rayos', match: 'hekton' },
    { key: 'marmol', label: 'Mármol', match: 'marmol' },
    { key: 'leopardo', label: 'Leopardo', match: 'leopardo' },
    { key: 'camuflaje', label: 'Camuflaje', match: 'camuflaje' },
    { key: 'zebra', label: 'Zebra', match: 'zebra' },
    { key: 'mapas', label: 'Map Lines', match: 'map-lines' }
  ];
  const cards = Array.from(grid.querySelectorAll('.product-card'));
  const hrefOf = (c) => (c.matches('a') ? c : c.querySelector('a[href*="/products/"]'))?.getAttribute('href') || '';
  const groups = STYLES.map((s) => ({ ...s, cards: cards.filter((c) => hrefOf(c).includes(s.match)) })).filter((s) => s.cards.length);
  if (!groups.length) return;

  const row = document.createElement('div');
  row.className = 'nx-style-filter';
  row.setAttribute('role', 'group');
  row.setAttribute('aria-label', 'Filtrar por estilo');
  groups.forEach((g) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'nx-style-btn';
    b.dataset.nxStyle = g.key;
    b.setAttribute('aria-pressed', 'false');
    const swatch = document.createElement('i');
    const img = g.cards[0].querySelector('.img-primary');
    // Muestra del propio vinilo: un trozo de la lámina de la portada
    if (img) swatch.style.backgroundImage = `url("${img.currentSrc || img.src}")`;
    const name = document.createElement('b');
    name.textContent = g.label;
    const n = document.createElement('span');
    n.textContent = g.cards.length;
    b.append(swatch, name, n);
    row.appendChild(b);
  });
  kinds.after(row);

  let active = '';
  const setStyle = (key) => {
    active = key;
    grid.classList.toggle('is-style-filtered', !!key);
    const g = groups.find((x) => x.key === key);
    cards.forEach((c) => c.classList.toggle('nx-style-off', !!g && !g.cards.includes(c)));
    if (g) g.cards.forEach((c) => c.classList.add('visible'));
    row.querySelectorAll('.nx-style-btn').forEach((b) => {
      const on = b.dataset.nxStyle === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      if (key) url.searchParams.set('estilo', key); else url.searchParams.delete('estilo');
      window.history.replaceState({}, '', url);
    }
  };
  row.addEventListener('click', (e) => {
    const b = e.target.closest('.nx-style-btn');
    if (!b) return;
    // Un estilo siempre es «con diseño»; pulsarlo otra vez lo quita
    kinds.querySelector('[data-nx-kind="diseno"]')?.click();
    setStyle(active === b.dataset.nxStyle ? '' : b.dataset.nxStyle);
  });
  kinds.addEventListener('click', (e) => {
    if (e.target.closest('.nx-kind-btn') && e.isTrusted) setStyle('');
  });
  const preset = new URLSearchParams(window.location.search).get('estilo');
  if (preset && groups.some((g) => g.key === preset)) row.querySelector(`[data-nx-style="${preset}"]`).click();
});
